// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '14.2.0-beta.20260915.1427';
